import React from "react";
import { Route, HashRouter as Router, Switch } from "react-router-dom";

import Details from "./Details";
import Enterprise from "./Enterprise";
import KeywordSearch from "./KeywordSearch";
import List from "./List";
import ListRedux from "./ListRedux";

const RecruitmentRouter = () => (
  <Router>
    <Switch>
      <Route exact path="/岗位/">
        <List />
      </Route>
      <Route exact path="/岗位/列表-redux">
        <ListRedux />
      </Route>
      <Route path="/岗位/企业/:id">
        <Enterprise />
      </Route>
      <Route path="/岗位/查询/">
        <KeywordSearch />
      </Route>
      <Route path="/岗位/:id">
        <Details />
      </Route>
    </Switch>
  </Router>
);

export default RecruitmentRouter;
